import 'govuk-frontend/dist/govuk/govuk-frontend.min.css'
import { GOVUK_COLOURS } from './colours'
import { GovUKTypography } from './GovUKTypography'

interface GovUKNotificationBannerProps {
  type: 'success' | 'error'
  message: string
  className?: string
}

const borderColour = {
  success: GOVUK_COLOURS.green,
  error: GOVUK_COLOURS.red,
}

export function GovUKNotificationBanner({
  type,
  message,
  className = '',
}: GovUKNotificationBannerProps) {
  const classes = [
    'govuk-notification-banner',
    type === 'success' ? 'govuk-notification-banner--success' : '',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div
      className={classes}
      role="alert"
      style={{ borderColor: borderColour[type] }}
    >
      <GovUKTypography variant="body" marginBottom={0}>
        {message}
      </GovUKTypography>
    </div>
  )
}
